module.exports = __webpack_public_path__ + "assets/instagram.64a47832.svg";